export const INTERVAL = Object.freeze({
  YEARLY: 1,
  QUARTERLY: 2,
})
